import { render, staticRenderFns } from "./factoryStock.vue?vue&type=template&id=4bd87baa"
import script from "./factoryStock.vue?vue&type=script&lang=js"
export * from "./factoryStock.vue?vue&type=script&lang=js"
import style0 from "./factoryStock.vue?vue&type=style&index=0&id=4bd87baa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports